import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Favorite from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";

const styles = {
  root: {
    color: green[600],
    "&$checked": {
      color: green[400]
    }
  },
  checked: {}
};

class CheckBox extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { classes } = this.props;
    return (
      <FormControlLabel
        control={
          <Checkbox
            onChange={() =>
              this.props.checkBoxChange(this.props.label, this.props.value)
            }
            color="primary"
            classes={{
              root: classes.root,
              checked: classes.checked
            }}
          />
        }
        label={this.props.label}
      />
    );
  }
}

CheckBox.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CheckBox);



// WEBPACK FOOTER //
// ./src/views/Audiences/CSegmentQueryBuilder/CheckBox.jsx